module.exports = __webpack_public_path__ + "assets/images/green-xmas-scrollyimage1.jpg?v=db727fe5";